import React from 'react';
export function Footer() {
  return <footer className="bg-ink-900 text-ink-400 py-12 text-center border-t border-ink-800" data-id="element-72">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="font-extrabold text-white text-xl mb-3 tracking-tight" data-id="element-74">
          Mega Pack <span className="text-brand-500" data-id="element-75">Artística Lista</span>
        </div>
        <p className="text-sm leading-relaxed max-w-2xl mx-auto" data-id="element-76">
          Material educativo profesional para docentes de Arte de nivel
          secundario. Diseñado por profes argentinas/os, para profes
          argentinas/os.
        </p>
        <div className="mt-8 text-xs text-ink-500" data-id="element-77">
          &copy; {new Date().getFullYear()} Mega Pack Artística Lista. Todos los
          derechos reservados.
        </div>
      </div>
    </footer>;
}